import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchProfile } from "../store/profileSlice";
import { useJobContext } from "../context/JobContext";
import ServiceRequestPanel from "../components/panels/ServiceRequestPanel";

const DashboardShell = () => {
  
  return (
    <>
      <Outlet />
    </>
  );
};

export default DashboardShell;
